import React, { useState } from "react";
import { Clock, CalendarDays, ExternalLink, User, Folder, X, Check } from "lucide-react";
import { INK, INK_2, INK_3, LINE, BURGUNDY, BURGUNDY_TINT } from "../../Bureau/bureauTokens";
import RecurrentAvailabilityPanel from "./RecurrentAvailabilityPanel";
import HolidaysSettingsPanel from "./HolidaysSettingsPanel";
import ReservationPageSettingsPanel from "./ReservationPageSettingsPanel";
import SharePlanningPanel from "./SharePlanningPanel";
import RoomsSettingsPanel from "./RoomsSettingsPanel";

const TABS = [
  { id: "recurrent", label: "Créneaux récurrents", icon: Clock },
  { id: "feries", label: "Jours fériés", icon: CalendarDays },
  { id: "reservation", label: "Page de réservation", icon: ExternalLink },
  { id: "partage", label: "Partage", icon: User },
  { id: "salles", label: "Salles", icon: Folder },
];

// Fidèle à MyALFA Worksync Test V2/planning.jsx (AvailabilityModal) : même
// en-tête, mêmes 5 onglets. Purement un routeur d'onglets — toutes les
// données et mutations viennent de Planning.jsx (même source de vérité que
// pour rooms/roomBookings existants), chaque panneau ne fait qu'afficher +
// appeler les callbacks reçus.
function PlanningSettingsModal({
  initialTab,
  regles,
  onRefreshRegles,
  parametresReservation,
  onUpdateParametresReservation,
  sharesGranted,
  onRefreshShares,
  rooms,
  defaultCabinetId,
  onRefreshRooms,
  onClose,
}) {
  const [tab, setTab] = useState(initialTab || "recurrent");

  return (
    <div className="fixed inset-0 z-[210] flex items-center justify-center p-4" style={{ background: "rgba(31,22,32,.45)" }} onClick={onClose}>
      <div
        className="w-full flex flex-col overflow-hidden"
        style={{ maxWidth: 640, maxHeight: "88vh", background: "#fff", borderRadius: 18, boxShadow: "0 24px 60px rgba(20,14,24,.30)" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3.5 px-5 py-4 flex-shrink-0" style={{ borderBottom: `1px solid ${LINE}` }}>
          <div
            className="flex items-center justify-center flex-shrink-0"
            style={{ width: 40, height: 40, borderRadius: 10, background: BURGUNDY_TINT, color: BURGUNDY }}
          >
            <Clock size={19} />
          </div>
          <div className="flex-1 min-w-0">
            <h2 className="text-sm font-semibold m-0" style={{ color: INK }}>
              Disponibilités &amp; réservation
            </h2>
            <div className="text-[11px] mt-0.5" style={{ color: INK_3 }}>
              Paramètres du planning et de la prise de RDV en ligne
            </div>
          </div>
          <button onClick={onClose} className="flex items-center justify-center flex-shrink-0" style={{ width: 32, height: 32, borderRadius: 8, border: `1px solid ${LINE}` }}>
            <X size={14} style={{ color: INK_2 }} />
          </button>
        </div>

        <div className="flex flex-wrap gap-1 px-5 py-2.5 flex-shrink-0" style={{ borderBottom: `1px solid ${LINE}` }}>
          {TABS.map((t) => {
            const Icon = t.icon;
            const active = tab === t.id;
            return (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                className="flex items-center gap-1.5 text-[11px] font-semibold px-3 py-1.5"
                style={{ borderRadius: 8, background: active ? BURGUNDY : "transparent", color: active ? "#fff" : INK_2 }}
              >
                <Icon size={13} /> {t.label}
              </button>
            );
          })}
        </div>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          {tab === "recurrent" && <RecurrentAvailabilityPanel regles={regles} onChange={onRefreshRegles} />}
          {tab === "feries" && parametresReservation && <HolidaysSettingsPanel params={parametresReservation} onUpdate={onUpdateParametresReservation} />}
          {tab === "reservation" && parametresReservation && <ReservationPageSettingsPanel params={parametresReservation} onUpdate={onUpdateParametresReservation} />}
          {tab === "partage" && <SharePlanningPanel shares={sharesGranted} onChange={onRefreshShares} />}
          {tab === "salles" && <RoomsSettingsPanel rooms={rooms} defaultCabinetId={defaultCabinetId} onChange={onRefreshRooms} />}
        </div>

        <div className="flex items-center justify-end px-5 py-3.5 flex-shrink-0" style={{ borderTop: `1px solid ${LINE}`, background: "#FAFAF8" }}>
          <button
            onClick={onClose}
            className="flex items-center gap-1.5 px-4 py-2 text-xs font-semibold text-white"
            style={{ background: BURGUNDY, borderRadius: 10 }}
          >
            <Check size={13} /> Terminé
          </button>
        </div>
      </div>
    </div>
  );
}

export default PlanningSettingsModal;
